import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconCustomPlatform: React.FC<IconProps> = ({color = 'var(--color-accent-1)'}): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="20"
            fill="none"
            viewBox="0 0 23 20"
        >
            <g clipPath="url(#clip0_30771_85483)">
                <path
                fill="#2F3467"
                d="M20.182 3.733L18.076.47A1.047 1.047 0 0017.198 0H4.082c-.356 0-.69.18-.878.471l-2.11 3.262C.006 5.415.969 7.756 3.002 8.026c.147.018.297.029.444.029.96 0 1.813-.41 2.397-1.043A3.255 3.255 0 008.24 8.055c.959 0 1.812-.41 2.396-1.043a3.255 3.255 0 002.397 1.043c.963 0 1.812-.41 2.397-1.043a3.26 3.26 0 002.396 1.043c.15 0 .298-.011.445-.029 2.04-.266 3.007-2.607 1.915-4.293h-.004zm-1.76 5.433h-.004a4.53 4.53 0 01-1.897-.151v4.793H4.76V9.011a4.478 4.478 0 01-1.908.155h-.004a4.335 4.335 0 01-.44-.083V16.11c0 1.269 1.054 2.301 2.352 2.301H16.52c1.298 0 2.353-1.032 2.353-2.301V9.083a3.58 3.58 0 01-.452.083z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_30771_85483">
                <path fill="#fff" d="M0 0H23V20H0z"></path>
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconCustomPlatform;
